import { withTheme } from 'theme';

const container = withTheme(() => ({
  width: '100%',
  background: '#EAF2FA',
  maxWidth: '900px',
  padding: '12px',
  gap: '12px',
  boxSizing: 'border-box'
}));

const details = withTheme((theme) => ({
  minWidth: 0,
  flex: 1,
  flexWrap: 'wrap',
  rowGap: theme.spacing(1)
}));

const icon = withTheme(() => ({
  width: '32px',
  height: '32px',
  objectFit: 'contain',
  flexShrink: 0
}));

const name = withTheme(() => ({
  minWidth: 0,
  overflowWrap: 'anywhere'
}));

const styles = {
  container,
  details,
  icon,
  name
};

export default styles;
